import { render, staticRenderFns } from "./CitySelectBox.vue?vue&type=template&id=6d18f55b&scoped=true&"
import script from "./CitySelectBox.vue?vue&type=script&lang=js&"
export * from "./CitySelectBox.vue?vue&type=script&lang=js&"
import style0 from "./CitySelectBox.vue?vue&type=style&index=0&id=6d18f55b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18f55b",
  null
  
)

export default component.exports